import layout from "~/layout/App/Index.vue";
import auth from "../middleware/auth";
import UserHistory from "~/views/CounterpartyAndUserHistory/User.vue";
import CounterpartiesHistory from "~/views/CounterpartyAndUserHistory/Counterparties.vue";

const historyRoutes = {
  path: "/history",
  component: layout,
  name: "history",
  meta: {
    breadcrumb: [{ name: 'history', route: "history.user.index" }],
    middleware: auth
  },
  children: [
    {
      path: "user",
      component: UserHistory,
      name: "history.user.index",
      meta: {
        middleware: auth,
        breadcrumb: [
          { name: 'history', route: "history.user.index" },
          { name: "name.user_chronicles" }
        ]
      }
    },
    {
      path: "counterparties",
      component: CounterpartiesHistory,
      name: "history.counterparties.index",
      meta: {
        middleware: auth,
        breadcrumb: [
          { name: 'history', route: "history.user.index" },
          { name: "name.counterparties_chronicles" }
        ]
      }
    }
  ]
};

export default historyRoutes;